export default {
  step1: 'Basic Info',
  step2: 'Attributes',
  step3: 'Spec/Price',
  step4: 'Details',
  productName: 'Product Name',
  productNameRequired: 'Please enter product name',
  productNamePlaceholder: 'Enter product name',
  productCategory: 'Category',
  productNo: 'Product Code',
  productNoRequired: 'Please enter product code',
  productNoPlaceholder: 'Enter product code',
  productImage: 'Product Image',
  productVideo: 'Product Video',
  videoCover: 'Video Cover',
  videoCoverUpload: 'Video Cover',
  productWeight: 'Weight',
  weightPlaceholder: 'Enter weight',
  weightUnit: 'kg',
  productUnit: 'Unit',
  unitPlaceholder: 'Enter unit',
  productBarcode: 'Barcode',
  barcodePlaceholder: 'Enter barcode',
  productRetailPrice: 'Retail Price',
  retailPricePlaceholder: 'Enter retail price',
  productMarketPrice: 'Market Price',
  marketPricePlaceholder: 'Enter market price',
  productAttributes: 'Attributes:',
  attrGroup: 'Attribute Group',
  attrValue: 'Attribute Value',
  action: 'Action',
  attrSelectPlaceholder: 'Select attribute first',
  addAttr: '+ Add',
  productSpec: 'Spec',
  singleSpec: 'Single Spec',
  multiSpec: 'Multi Spec',
  productPrice: 'Price',
  priceRequired: 'Please enter price',
  pricePlaceholder: 'Enter price',
  priceUnit: 'USD',
  specNamePlaceholder: 'Spec name',
  specValuePlaceholder: 'Spec value',
  addSpecValue: '+ Add',
  addSpec: '+ Add Spec',
  generateSpec: '+ Generate',
  applySpecChanges: 'Rename Spec',
  specImage: 'Spec Image',
  specPrice: 'Price ($)',
  specWeight: 'Weight',
  specVirtualSales: 'Virtual Sales',
  specNo: 'Spec No.',
  specNoPlaceholder: 'Enter spec no.',
  specNoRequired: 'Spec No. is required',
  specImageRequired: 'Spec image is required',
  specMatrixRequired: 'Please generate spec matrix first',
  select: 'Select',
  productDetail: 'Details',
  detailPlaceholder: 'Enter detail content',
  phonePreview: 'Product Detail',
};
